module.exports = __webpack_public_path__ + "static/media/ap-logo.ca188a96.jpeg";